<template>
  <div class="app-admin-page">
    <div class="app-admin-card">
      <div class="toolbar">
        <div>
          <div class="title">B站推送</div>
          <div class="muted">AstrBot 目标、UP 主订阅和推送类型开关</div>
        </div>
        <el-button icon="el-icon-refresh" @click="refreshAll">刷新</el-button>
      </div>

      <el-row :gutter="18">
        <el-col :span="8">
          <div class="section">
            <div class="section-title">推送目标</div>
            <el-form label-position="top" size="small">
              <el-form-item label="目标 ID">
                <el-input v-model="groupForm.target_id" placeholder="default:GroupMessage:1063305936"></el-input>
              </el-form-item>
              <el-form-item label="名称">
                <el-input v-model="groupForm.name" placeholder="群名或备注"></el-input>
              </el-form-item>
              <div class="form-row">
                <el-switch v-model="groupForm.enabled" active-text="启用"></el-switch>
                <el-button type="primary" icon="el-icon-check" @click="saveGroup">保存目标</el-button>
              </div>
            </el-form>

            <el-table :data="groups" height="52vh" size="small" class="group-table" @row-click="selectGroup">
              <el-table-column label="目标" min-width="180">
                <template slot-scope="scope">
                  <div class="strong">{{ scope.row.name || scope.row.target_id }}</div>
                  <div class="muted mono">{{ scope.row.target_id }}</div>
                </template>
              </el-table-column>
              <el-table-column label="状态" width="80">
                <template slot-scope="scope">
                  <el-tag size="mini" :type="scope.row.enabled ? 'success' : 'info'">{{ scope.row.enabled ? "启用" : "停用" }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="86">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click.stop="editGroup(scope.row)">编辑</el-button>
                  <el-button type="text" size="mini" class="danger" @click.stop="deleteGroup(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>

        <el-col :span="16">
          <div class="section">
            <div class="section-head">
              <div>
                <div class="section-title">UP 主订阅</div>
                <div class="muted mono">{{ selectedTarget || "未选择目标" }}</div>
              </div>
              <div class="search-row">
                <el-button icon="el-icon-position" @click="openManual()">手动推送</el-button>
                <el-input v-model="keyword" placeholder="搜索昵称或输入 UID" clearable @keyup.enter.native="searchUsers"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="searchUsers">搜索</el-button>
              </div>
            </div>

            <el-alert
              v-if="!selectedTarget"
              type="info"
              :closable="false"
              show-icon
              title="请选择或新增一个推送目标"
            />

            <el-table v-if="searchResults.length" :data="searchResults" size="small" border class="search-table">
              <el-table-column label="用户" min-width="220">
                <template slot-scope="scope">
                  <div class="user-cell">
                    <img class="avatar" :src="scope.row.face" referrerpolicy="no-referrer" />
                    <div>
                      <div class="strong">{{ scope.row.uname }}</div>
                      <div class="muted">UID：{{ scope.row.bili_uid }} · Lv.{{ scope.row.level || 0 }}</div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="sign" label="签名" min-width="220" show-overflow-tooltip></el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="addUser(scope.row)">添加</el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-table :data="subscriptions" height="50vh" border size="small" class="sub-table">
              <el-table-column label="UP 主" min-width="190">
                <template slot-scope="scope">
                  <div class="user-cell">
                    <img class="avatar" :src="scope.row.face" referrerpolicy="no-referrer" />
                    <div>
                      <div class="strong">{{ scope.row.uname || scope.row.bili_uid }}</div>
                      <div class="muted">UID：{{ scope.row.bili_uid }}</div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="开关" min-width="420">
                <template slot-scope="scope">
                  <div class="switch-grid">
                    <label v-for="item in switchFields" :key="item.key">
                      <span>{{ item.label }}</span>
                      <el-switch v-model="scope.row[item.key]" @change="saveSubscription(scope.row)"></el-switch>
                    </label>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="状态" width="160">
                <template slot-scope="scope">
                  <div>
                    <el-tag size="mini" :type="scope.row.live_status ? 'danger' : 'info'">{{ scope.row.live_status ? "直播中" : "未开播" }}</el-tag>
                  </div>
                  <div class="muted">动态：{{ scope.row.last_dynamic_id || "-" }}</div>
                </template>
              </el-table-column>
              <el-table-column label="更新时间" width="150">
                <template slot-scope="scope">{{ formatTime(scope.row.updated_at) }}</template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="128">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="openManual(scope.row)">手推</el-button>
                  <el-button type="text" size="mini" class="danger" @click="deleteSubscription(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-table :data="manualJobs" size="mini" border class="job-table">
              <el-table-column prop="id" label="任务" width="70"></el-table-column>
              <el-table-column label="UP 主" min-width="150">
                <template slot-scope="scope">{{ scope.row.uname || scope.row.bili_uid }}</template>
              </el-table-column>
              <el-table-column prop="count" label="条数" width="70"></el-table-column>
              <el-table-column label="状态" width="90">
                <template slot-scope="scope">
                  <el-tag size="mini" :type="jobTagType(scope.row.status)">{{ scope.row.status }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="message" label="消息" min-width="170" show-overflow-tooltip></el-table-column>
              <el-table-column prop="error" label="错误" min-width="170" show-overflow-tooltip></el-table-column>
              <el-table-column label="创建时间" width="145">
                <template slot-scope="scope">{{ formatTime(scope.row.created_at) }}</template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-dialog title="手动推送" :visible.sync="manualVisible" width="520px">
      <el-form label-position="top">
        <el-form-item label="推送目标">
          <el-select v-model="manualForm.target_id" filterable style="width: 100%">
            <el-option
              v-for="item in groups"
              :key="item.target_id"
              :label="item.name || item.target_id"
              :value="item.target_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="B站 UID">
          <el-input v-model="manualForm.bili_uid" placeholder="输入 UID 或从订阅行打开"></el-input>
        </el-form-item>
        <el-form-item label="推送条数">
          <el-input-number v-model="manualForm.count" :min="1" :max="10" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-switch v-model="manualForm.at_all" active-text="at 全体"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="manualVisible = false">取消</el-button>
        <el-button type="primary" @click="createManualJob">创建任务</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { post } from "../axios/request.js";
import { formatTime, isSuccess } from "./appAdminUtils.js";

export default {
  name: "appBilibiliPush",
  data() {
    return {
      groups: [],
      subscriptions: [],
      searchResults: [],
      manualJobs: [],
      selectedTarget: "",
      keyword: "",
      manualVisible: false,
      manualForm: {
        target_id: "",
        bili_uid: "",
        uname: "",
        count: 1,
        at_all: false,
      },
      groupForm: {
        target_id: "",
        name: "",
        enabled: true,
      },
      switchFields: [
        { key: "enabled", label: "推送" },
        { key: "at_all", label: "全体" },
        { key: "push_dynamic", label: "动态" },
        { key: "push_live", label: "直播" },
        { key: "push_video", label: "视频" },
        { key: "push_article", label: "专栏" },
        { key: "push_draw", label: "图文" },
        { key: "push_word", label: "文字" },
        { key: "push_forward", label: "转发" },
      ],
    };
  },
  mounted() {
    this.loadGroups();
  },
  methods: {
    formatTime,
    refreshAll() {
      this.loadGroups();
      if (this.selectedTarget) {
        this.loadSubscriptions();
        this.loadManualJobs();
      }
    },
    loadGroups() {
      post("/api/admin/bilibili/push/groups", {}).then((res) => {
        if (!isSuccess(res)) {
          this.$message.error(res.data.msg || "目标列表获取失败");
          return;
        }
        this.groups = res.data.data || [];
        if (!this.selectedTarget && this.groups.length) {
          this.selectGroup(this.groups[0]);
        }
      });
    },
    selectGroup(row) {
      this.selectedTarget = row.target_id;
      this.groupForm = {
        target_id: row.target_id,
        name: row.name,
        enabled: !!row.enabled,
      };
      this.searchResults = [];
      this.loadSubscriptions();
      this.loadManualJobs();
    },
    editGroup(row) {
      this.selectGroup(row);
    },
    saveGroup() {
      const payload = {
        target_id: this.groupForm.target_id,
        name: this.groupForm.name,
        enabled: this.groupForm.enabled ? 1 : 0,
      };
      post("/api/admin/bilibili/push/group/save", payload).then((res) => {
        if (isSuccess(res)) {
          this.$message.success(res.data.msg || "保存成功");
          this.selectedTarget = payload.target_id;
          this.loadGroups();
          this.loadSubscriptions();
        } else {
          this.$message.error(res.data.msg || "保存失败");
        }
      });
    },
    deleteGroup(row) {
      this.$confirm("删除后会同时移除该目标下的订阅，确定继续吗？", "删除推送目标", { type: "warning" }).then(() => {
        post("/api/admin/bilibili/push/group/delete", { target_id: row.target_id }).then((res) => {
          if (isSuccess(res)) {
            this.$message.success(res.data.msg || "删除成功");
            if (this.selectedTarget === row.target_id) {
              this.selectedTarget = "";
              this.subscriptions = [];
            }
            this.loadGroups();
          } else {
            this.$message.error(res.data.msg || "删除失败");
          }
        });
      });
    },
    loadSubscriptions() {
      if (!this.selectedTarget) {
        return;
      }
      post("/api/admin/bilibili/push/subscriptions", { target_id: this.selectedTarget }).then((res) => {
        if (isSuccess(res)) {
          this.subscriptions = res.data.data || [];
          this.loadManualJobs();
        } else {
          this.$message.error(res.data.msg || "订阅列表获取失败");
        }
      });
    },
    loadManualJobs() {
      post("/api/admin/bilibili/push/manual/jobs", { target_id: this.selectedTarget }).then((res) => {
        if (isSuccess(res)) {
          this.manualJobs = res.data.data || [];
        }
      });
    },
    searchUsers() {
      if (!this.selectedTarget) {
        this.$message.warning("请先选择推送目标");
        return;
      }
      post("/api/admin/bilibili/push/search", { keyword: this.keyword }).then((res) => {
        if (isSuccess(res)) {
          this.searchResults = res.data.data || [];
        } else {
          this.$message.error(res.data.msg || "搜索失败");
        }
      });
    },
    addUser(user) {
      const payload = {
        target_id: this.selectedTarget,
        bili_uid: user.bili_uid,
        uname: user.uname,
        face: user.face,
        enabled: 1,
        at_all: 0,
        push_dynamic: 1,
        push_live: 1,
        push_video: 1,
        push_article: 1,
        push_draw: 1,
        push_word: 1,
        push_forward: 1,
      };
      post("/api/admin/bilibili/push/subscription/save", payload).then((res) => {
        if (isSuccess(res)) {
          this.$message.success("已添加订阅");
          this.loadSubscriptions();
        } else {
          this.$message.error(res.data.msg || "添加失败");
        }
      });
    },
    saveSubscription(row) {
      const payload = {
        target_id: row.target_id,
        bili_uid: row.bili_uid,
        uname: row.uname,
        face: row.face,
        last_dynamic_id: row.last_dynamic_id,
      };
      this.switchFields.forEach((item) => {
        payload[item.key] = row[item.key] ? 1 : 0;
      });
      post("/api/admin/bilibili/push/subscription/save", payload).then((res) => {
        if (!isSuccess(res)) {
          this.$message.error(res.data.msg || "保存失败");
          this.loadSubscriptions();
        }
      });
    },
    deleteSubscription(row) {
      this.$confirm(`删除 ${row.uname || row.bili_uid} 的订阅？`, "删除订阅", { type: "warning" }).then(() => {
        post("/api/admin/bilibili/push/subscription/delete", {
          target_id: row.target_id,
          bili_uid: row.bili_uid,
        }).then((res) => {
          if (isSuccess(res)) {
            this.$message.success(res.data.msg || "删除成功");
            this.loadSubscriptions();
          } else {
            this.$message.error(res.data.msg || "删除失败");
          }
        });
      });
    },
    openManual(row) {
      this.manualForm = {
        target_id: (row && row.target_id) || this.selectedTarget,
        bili_uid: (row && row.bili_uid) || "",
        uname: (row && row.uname) || "",
        count: 1,
        at_all: false,
      };
      this.manualVisible = true;
    },
    createManualJob() {
      const payload = {
        target_id: this.manualForm.target_id,
        bili_uid: this.manualForm.bili_uid,
        uname: this.manualForm.uname,
        count: this.manualForm.count,
        at_all: this.manualForm.at_all ? 1 : 0,
      };
      post("/api/admin/bilibili/push/manual/create", payload).then((res) => {
        if (isSuccess(res)) {
          this.$message.success(res.data.msg || "任务已创建");
          this.manualVisible = false;
          this.loadManualJobs();
        } else {
          this.$message.error(res.data.msg || "任务创建失败");
        }
      });
    },
    jobTagType(status) {
      if (status === "done") {
        return "success";
      }
      if (status === "failed") {
        return "danger";
      }
      if (status === "processing") {
        return "warning";
      }
      return "info";
    },
  },
};
</script>

<style scoped>
.app-admin-page {
  width: 100%;
  height: 100%;
  background: #f5f7fb;
  overflow: auto;
}
.app-admin-card {
  width: 98%;
  min-height: 92%;
  margin: 1.5% auto;
  padding: 22px;
  background: #fff;
  box-shadow: #e0e0e0 5px 5px 10px;
  box-sizing: border-box;
}
.toolbar,
.section-head,
.form-row,
.search-row {
  display: flex;
  align-items: center;
}
.toolbar,
.section-head {
  justify-content: space-between;
  margin-bottom: 18px;
}
.form-row {
  justify-content: space-between;
}
.search-row {
  width: 420px;
  gap: 10px;
}
.title {
  color: #1f2d3d;
  font-size: 22px;
  font-weight: 700;
}
.section {
  border: 1px solid #e6ebf2;
  padding: 16px;
  min-height: 72vh;
  box-sizing: border-box;
}
.section-title {
  color: #1f2d3d;
  font-size: 16px;
  font-weight: 700;
}
.muted {
  color: #7f8fa4;
  font-size: 12px;
}
.mono {
  font-family: Consolas, Monaco, monospace;
}
.strong {
  color: #263445;
  font-weight: 600;
}
.danger {
  color: #f56c6c;
}
.group-table,
.search-table,
.sub-table,
.job-table {
  margin-top: 14px;
}
.user-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}
.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  background: #eef2f7;
  flex: 0 0 auto;
}
.switch-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(96px, 1fr));
  gap: 8px 14px;
}
.switch-grid label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #4d5b6a;
  font-size: 12px;
}
</style>
